/**
 * HomeScreen tradition door display data.
 * IDs must match LibraryScreen's Tradition type ("zen" | "vipassana" | "secular").
 * This file is a presentation-layer mapping — not a content authority.
 * The content authority is packages/content/src/traditions/.
 * HomeScreen receives this data via props from the bridge (not via direct import).
 */

export type TraditionRow = {
  id: string;
  seal: string;
  name: string;
  term: string;
  line: string;
};

export const TRADITION_ROWS: TraditionRow[] = [
  { id: "zen",       seal: "#6f7d5e", name: "Sōtō Zen",      term: "zazen · kinhin",      line: "Just sitting. The wall, the breath, the bell." },
  { id: "vipassana", seal: "#9a6f53", name: "Vipassana",      term: "ānāpāna · sensation", line: "Watching sensation until it loosens its grip." },
  { id: "secular",   seal: "#6f7c86", name: "Modern secular", term: "breath · body scan",  line: "Plain language. Breath, body, a little stillness." },
];

const TRADITION_NAME_BY_ID: Readonly<Record<string, string>> = Object.fromEntries(
  TRADITION_ROWS.map((r) => [r.id, r.name]),
);

/** Returns the user-facing tradition name for a given tradition ID. Falls back to the raw ID. */
export function traditionLabel(id: string): string {
  return TRADITION_NAME_BY_ID[id] ?? id;
}
